/**
 * @file store actions
 * @author zhangzhimeng
 */

import apis from '../apis/column'
import home from '../apis/home'
import tenant from '../apis/tenant'
import apisfooter from '../apis/dict'
import {setTenantId, setTenantName, setWebsitBanner, setWebsitLogo, setWebsitName} from '../utils/auth'
export default {
  getColumnTreeList (ctx) {
    apis.listColumnTree().then(res => {
      ctx.commit('SET_COLUMNTREELIST', res)
    })
  },
  getTenant (ctx) {
    tenant.getTenant().then(res => {
      setTenantId(res.id)
      setTenantName(res.name)
      ctx.commit('SET_TENANT', res)
    })
  },
  getWebsit (ctx) {
    home.getWebsit().then(res => {
      setWebsitBanner(res)
      setWebsitName(res)
      setWebsitLogo(res)
      ctx.commit('SET_BANNER', res.bannerPath)
      ctx.commit('SET_WEBSIT', res)
      ctx.commit('SET_SITEINTRO', res.siteIntro)
    })
  },
  getFooterList (ctx) {
    const { state } = ctx
    const { footerList } = state
    console.log(footerList)
    if (footerList.length > 0) return
    apisfooter.dictList({dictType: 'WebsiteConfig'}).then(res => {
      ctx.commit('SET_FOOTERLIST', res)
    })
  },
  SET_PERMISSION (context, permissionList) {
    // 提交到 mutation 中的 SET_PERMISSION 函数
    context.commit('SET_PERMISSION', permissionList)
  },
  login ({ commit }, token) {
    commit('SET_LOGGED_IN', true)
  },
  logout ({ commit }) {
    commit('SET_LOGGED_IN', false)
  },
  removeRedirect ({ commit }, token) {
    console.log('removeRedirect',666666666)
    commit('SET_REDIRECT_PATH', null) // 清除重定向路径
  }
}
